import React from "react";
import classNames from "classnames";
import { FORM_HEAD_ID } from "../../constants";

interface Props {
  description?: string;
  descriptionClassName?: string;
  style?: React.CSSProperties;
  title?: string;
  titleClassName?: string;
  titleStyle?: React.CSSProperties;
}

const FormHead = ({
  description,
  descriptionClassName,
  style,
  title,
  titleClassName,
  titleStyle
}: Props) => (
  <div key={FORM_HEAD_ID} style={style}>
    {title && (
      <h1
        className={classNames("text-center", titleClassName)}
        dangerouslySetInnerHTML={{ __html: title }}
        style={titleStyle}
      />
    )}
    {description && (
      <p
        className={descriptionClassName}
        dangerouslySetInnerHTML={{ __html: description }}
      />
    )}
  </div>
);

export default FormHead;
